import { convertLabelMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.Weather`]: `Weather`,
      [`${prefix}.Preparation.DynamicConePenetrometer`]: `Dynamic Cone Penetrometer`,
      [`${prefix}.Preparation.ConeCheckBy`]: `Cone Check By`,
      [`${prefix}.Preparation.ConeDiameterSatisfactory`]: `Cone diameter satisfactory`,
      [`${prefix}.Preparation.Callipers`]: `Callipers`,
      [`${prefix}.Preparation.Measure`]: `Measure`,
      [`${prefix}.Preparation.TimeOfTest`]: `Time of Test`,
      [`${prefix}.Preparation.StartDepth`]: `Start Depth`,
      [`${prefix}.Preparation.DcpOffset`]: `DCP Offset`,
      [`${prefix}.Preparation.ZeroReading`]: `Zero Reading`,

      [`${prefix}.Measurements.ResultNotObtainable`]: `Result not obtainable`,
      [`${prefix}.Measurements.ResultNotObtainableReason`]: `Reason`,
      [`${prefix}.Measurements.UnableToPenetrateFurther`]: `Unable to penetrate further`,    

      [`${prefix}.Measurements.Measurements.Blows`]: `Blows`,
      [`${prefix}.Measurements.Measurements.TotalBlows`]: `Total Blows`,
      [`${prefix}.Measurements.Measurements.DepthReading`]: `Depth Reading`,
      [`${prefix}.Measurements.Measurements.ExtensionUsed`]: `Extension Used`,
      [`${prefix}.Measurements.Measurements.Offset`]: `Offset`,
      [`${prefix}.Measurements.Measurements.Depth`]: `Depth`,

      [`${prefix}.Results.JoinLayersOnChart`]: `Include Regression Lines`,
      [`${prefix}.Results.StartDepth`]: `Start Depth`,
      [`${prefix}.Results.FinalDepth`]: `Final Depth`,

      [`${prefix}.Results.LayerBoundaries.TotalBlows`]: `Total Blows`,
      [`${prefix}.Results.LayerBoundaries.Depth`]: `Depth`,
      [`${prefix}.Results.LayerBoundaries.LayerThickness`]: `Layer Thickness`,
      [`${prefix}.Results.LayerBoundaries.PenetrationRate`]: `mm/Blow`,
      [`${prefix}.Results.LayerBoundaries.CBR`]: `CBR`,
    })
  );

export default getLabelConfig;
